import { Box, Stack } from "@mui/material";
import { IWikifolioDetailData, IWikifolioDetailDict } from "src/api/server/wf-detail.types";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { InvestmentUniverse } from "src/components-mui/pages/detail/trading-idea-section/investment-universe";
import { MasterData } from "src/components-mui/pages/detail/trading-idea-section/master-data";
import { TradingIdea } from "src/components-mui/pages/detail/trading-idea-section/trading-idea";

export interface ITradingIdeaSectionProps {
    isTranslationNecessary: IWikifolioDetailData["isTranslationNecessary"];
    description: IWikifolioDetailData["wikifolio"]["description"];
    masterData: IWikifolioDetailData["masterData"];
    investmentUniverseData: IWikifolioDetailData["investmentUniverseData"];
    dict: Pick<IWikifolioDetailDict, "tradingIdeaSection" | "investmentUniverseTitle" | "superWikifolioInvestmentUniverseParagraph">;
}

export const TradingIdeaSection = (props: ITradingIdeaSectionProps) => {
    const { dict, isTranslationNecessary, description, masterData, investmentUniverseData } = props;

    return (
        <Stack component="section" spacing={3} sx={{ mb: 4 }}>
            <WfHeading component="h2" fontSize="2xl">
                {dict.tradingIdeaSection.tradingIdeaTitle}
            </WfHeading>
            <TradingIdea dict={dict.tradingIdeaSection} isTranslationNecessary={isTranslationNecessary} description={description} />

            <Box sx={{ fontSize: "sm" }}>
                <WfHeading component="h3" fontSize="lg" sx={{ mb: 3, pt: 2 }}>
                    {dict.tradingIdeaSection.masterDataTitle}
                </WfHeading>
                <MasterData masterData={masterData} />
            </Box>
            {investmentUniverseData && <InvestmentUniverse data={investmentUniverseData} dict={dict} />}
        </Stack>
    );
};
